// extracted by mini-css-extract-plugin
module.exports = {"scaleInput":"ScaleInput_scaleInput__yueVI","scaleIconSmall":"ScaleInput_scaleIconSmall__lWeTE","scaleIconBig":"ScaleInput_scaleIconBig__RU3Gx"};